var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProwessIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786 -1407)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(786 1407)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(828 1412)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800 1412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.219,48.774a.966.966,0,0,1-.553.5,9.4,9.4,0,0,0-.657,3.249c0,.1,0,.206,0,.311h8.122c0-.1,0-.2,0-.311a9.623,9.623,0,0,0-.729-3.438.951.951,0,0,1-.475-.46c-.8-1.671-1.88-2.709-2.82-2.709C31.148,45.919,30.014,47.04,29.219,48.774Z",
    transform: "translate(-20.614 -16.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.077,17.131c.006.094.015.188.024.282.63,7.139,4.807,12.655,9.866,12.655s9.236-5.517,9.867-12.655c.01-.094.016-.187.024-.282.045-.31.074-.624.093-.942.013-.217.021-.435.021-.656a11.343,11.343,0,0,0-.114-1.6,9.942,9.942,0,0,0-19.782,0,11.134,11.134,0,0,0-.114,1.6c0,.221.009.439.02.656C36,16.507,36.031,16.821,36.077,17.131ZM39.8,11.452a16.962,16.962,0,0,0,6.172,1.488,16.957,16.957,0,0,0,6.172-1.488c2.087.823,1.1,6.691,1.1,6.692a4.2,4.2,0,0,1,1.388-.65c-.574,6.236-4.23,11.045-8.657,11.045s-8.084-4.809-8.658-11.045a4.2,4.2,0,0,1,1.388.65S37.709,12.275,39.8,11.452Z",
    transform: "translate(-22.899 -5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.473,
    cy: 1.473,
    r: 1.473,
    transform: "translate(33.258 28.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.252,92.936H24.913a.736.736,0,1,0,0,1.471H60.252a.736.736,0,1,0,0-1.471Z",
    transform: "translate(-19.514 -30.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.48,50.749a13.075,13.075,0,0,0-7.929-11.16c.021.045.046.086.069.132a6.3,6.3,0,0,1,.54,1.821,2.939,2.939,0,1,1-1.383-.051,5.031,5.031,0,0,0-1.377-2.6A13.033,13.033,0,0,0,48.64,38.6c-.052,2.383-7.937,8.234-7.937,8.234s-7.885-5.85-7.936-8.234q-.632.058-1.246.175a4.867,4.867,0,0,0-1.707,2.584,1.628,1.628,0,0,1,.715.844,6.842,6.842,0,0,1,3.15,3.5.952.952,0,0,1,.006.812,11.017,11.017,0,0,1,.816,3.913c0,.105,0,.209,0,.311H23.683c0-.1,0-.2,0-.311a10.841,10.841,0,0,1,.786-3.831.942.942,0,0,1,.029-.719,8.92,8.92,0,0,1,1.837-2.707,4.892,4.892,0,0,1,1.3-.917,1.643,1.643,0,0,1,.822-.935,5.037,5.037,0,0,1,.683-1.845,13.079,13.079,0,0,0-8.214,11.279,3.583,3.583,0,0,0-3.293,3.565V54.4l.014.082,3.236,18.763a3.584,3.584,0,0,0,3.579,3.49H56.944a3.584,3.584,0,0,0,3.579-3.49l3.235-18.763.015-.082v-.085A3.584,3.584,0,0,0,60.48,50.749Zm-.938,22.4a2.6,2.6,0,0,1-2.6,2.6H24.462a2.6,2.6,0,0,1-2.6-2.6l-3.249-18.84a2.6,2.6,0,0,1,2.6-2.6H60.19a2.6,2.6,0,0,1,2.6,2.6Z",
    transform: "translate(-17.634 -14.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.379,71.7a1.54,1.54,0,1,0,1.54,1.538A1.54,1.54,0,0,0,49.379,71.7Z",
    transform: "translate(-26.31 -24.161)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwessIcon1);
export default __webpack_public_path__ + "static/media/prowess-icon1.10c39f1a10d7f8171c76f9e4e61cd59c.svg";
export { ForwardRef as ReactComponent };